import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../../../modules/localization/useDateTime"
import type { DeliveryOpeningLimits } from "../../helpers"

import { DeliveryMessageBox } from "./DeliveryMessageBox"

type DeliveryTimeWarningProps = Readonly<{
    // The shop's configured window, not the picker bounds: those are narrowed to "now" for
    // today and would claim the shop closes at some other time than it does.
    openingLimits: DeliveryOpeningLimits | null
}>

/**
 * The one case where no delivery is possible at all: the delivery date is today and the shop
 * has already closed. The user has to pick another date.
 */
export function DeliveryTimeWarning({ openingLimits }: DeliveryTimeWarningProps) {
    const dateTimeFactory = useDateTime()

    const closingTime = openingLimits ? dateTimeFactory.toHourMinute(openingLimits.maxTime) : ""

    return (
        <LocalizedStrict
            id="create-order-delivery-times-dialog-delivery-time-event-start-today"
            vars={{ time: closingTime }}
        >
            <DeliveryMessageBox isBlocking>
                Unfortunately you can't create a meeting service order today, because merchant does not deliver later
                than {closingTime}
            </DeliveryMessageBox>
        </LocalizedStrict>
    )
}
